import { PriceInterval } from '@griply/types';
import { useCallback, useContext } from 'react';

import { PremiumDialogContext } from './premium-dialog-context';

export const useOpenPremiumDialog = () => {
  const { openPremiumDialog } = useContext(PremiumDialogContext);

  return useCallback(() => openPremiumDialog(), [openPremiumDialog]);
};

export const useOpenPremiumDialogWithPriceSelection = () => {
  const { openPremiumDialog } = useContext(PremiumDialogContext);

  return useCallback(
    (priceInterval?: PriceInterval) => openPremiumDialog(priceInterval),
    [openPremiumDialog],
  );
};
